<template>
  <section class="px-4 py-2 space-y-6">

<div class="flex justify-between items-center border-b border-gray-200 py-4 mb-6">
  <div>
    <h1 class="text-xl font-semibold text-gray-800">
      Bienvenue {{ clientName || 'Client' }} 👋
    </h1>
    <p class="text-sm text-gray-500">
      Voici le récapitulatif de vos projets et activités
    </p>
  </div>
  
  <span class="text-sm text-gray-500">
    {{ currentTime }}
  </span>
</div>


<!-- Cards -->
<div class="grid sm:grid-cols-2 xl:grid-cols-4 gap-4">
  <!-- Card: Projets en cours -->
  <div class="rounded-2xl bg-white shadow-sm border border-gray-100 p-5">
    <div class="flex items-center justify-between">
      <div class="text-sm font-medium text-gray-500">Projets en cours</div>
      <div class="p-2 rounded-xl bg-gray-50">
        <svg class="w-5 h-5 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path stroke-width="1.5" d="M3 7.5 12 13.5 21 7.5"/>
          <rect x="3" y="5.25" width="18" height="13.5" rx="2.25" stroke-width="1.5"/>
        </svg>
      </div>
    </div>
    <div class="mt-3 flex items-baseline gap-2">
      <div class="text-3xl font-semibold text-gray-900">{{ projetsActifs }}</div>
      <div class="text-xs text-gray-500">actifs</div>
    </div>
  </div>

  <!-- Card: Devis à signer -->
  <div class="rounded-2xl bg-white shadow-sm border border-gray-100 p-5">
    <div class="flex items-center justify-between">
      <div class="text-sm font-medium text-gray-500">Devis à signer</div>
      <div class="p-2 rounded-xl bg-gray-50">
        <svg class="w-5 h-5 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path stroke-width="1.5" d="M7.5 8.25h9M7.5 12h6M4.5 19.5l3.75-3.75h9.75A2.25 2.25 0 0 0 20.25 13.5V6.75A2.25 2.25 0 0 0 18 4.5H6A2.25 2.25 0 0 0 3.75 6.75v9"/>
        </svg>
      </div>
    </div>
    <div class="mt-3 flex items-baseline gap-2">
      <div class="text-3xl font-semibold text-gray-900">{{ devisEnAttente }}</div>
      <div class="text-xs text-gray-500">en attente</div>
    </div>
  </div>

  <!-- Card: Factures impayées -->
  <div class="rounded-2xl bg-white shadow-sm border border-gray-100 p-5">
    <div class="flex items-center justify-between">
      <div class="text-sm font-medium text-gray-500">Factures impayées</div>
      <div class="p-2 rounded-xl bg-gray-50">
        <svg class="w-5 h-5 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path stroke-width="1.5" d="M21 10.5v6.75A2.25 2.25 0 0 1 18.75 19.5H5.25A2.25 2.25 0 0 1 3 17.25V6.75A2.25 2.25 0 0 1 5.25 4.5H12"/>
          <path stroke-width="1.5" d="M21 10.5H14.25A2.25 2.25 0 0 1 12 8.25V4.5L21 10.5Z"/>
        </svg>
      </div>
    </div>
    <div class="mt-3 flex items-baseline gap-2">
      <div class="text-3xl font-semibold text-gray-900">{{ facturesImpayees }}</div>
      <div class="text-xs text-gray-500">à régler</div>
    </div>
  </div>

  <!-- Card: Tickets / Support -->
  <div class="rounded-2xl bg-white shadow-sm border border-gray-100 p-5">
    <div class="flex items-center justify-between">
      <div class="text-sm font-medium text-gray-500">Tickets ouverts</div>
      <div class="p-2 rounded-xl bg-gray-50">
        <svg class="w-5 h-5 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path stroke-width="1.5" d="M3 12l4-4 4 4 6-6"/>
          <path stroke-width="1.5" d="M17 6h4v4"/>
        </svg>
      </div>
    </div>
    <div class="mt-3 flex items-center justify-between">
      <div class="flex items-baseline gap-2">
        <div class="text-3xl font-semibold text-gray-900">{{ ticketsCount }}</div>
      </div>

    </div>
  </div>
</div>


<div class="flex flex-col md:flex-row gap-4 mt-8 w-full">
  <div class="w-full md:w-1/2">
    <ResponseRateHistory />
  </div>
  <div class="w-full md:w-1/2">
    <GrowthHistory />
  </div>
</div>


   
   

            <ContactsHistory />


   
  </section>
</template>

<script>
import { ref, onMounted, onUnmounted, computed } from "vue";
import ContactsHistory from "@/components/Graphique/ContactsHistory.vue";
import ResponseRateHistory from "@/components/Graphique/ResponseRateHistory.vue";
import GrowthHistory from "@/components/Graphique/GrowthHistory.vue";
export default {
  name: "DashboardView",
  components: {
    ContactsHistory,
    ResponseRateHistory,
    GrowthHistory,
  },
  setup() {
    // Données dynamiques du dashboard
    const projetsActifs = ref(0);
    const devisEnAttente = ref(0);
    const facturesImpayees = ref(0);
    const ticketsCount = ref(0);
    const ticketsGrowth = ref(0);

    const clientName = ref("");
    const currentTime = ref("");

    // Mettre à jour l'heure toutes les secondes
    const updateTime = () => {
      const now = new Date();
      currentTime.value = now.toLocaleTimeString("fr-FR", { hour12: false });
    };

    let intervalId;
    onMounted(() => {
      updateTime();
      intervalId = setInterval(updateTime, 1000);
      console.log(localStorage.getItem("token"))
      // ⚡ Appel API dashboard
      fetch("https://datafuseweb-95a5588f8542.herokuapp.com/api/clients/dashboard", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // ou ton token auth
        },
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.client) clientName.value = data.client.prenom || data.client.nom || "Client";

          // ⚡ Stats du dashboard
          if (data.stats) {
            projetsActifs.value = data.stats.projetsEnCours;
            devisEnAttente.value = data.devis.filter(d => d.statut !== "Signé" && d.statut !== "Terminé").length;
            facturesImpayees.value = data.stats.facturesEnAttente;
            ticketsCount.value = data.stats.totalTickets;
            ticketsGrowth.value = data.stats.ticketsOuverts / Math.max(data.stats.totalTickets,1) * 100; // exemple de calcul
          }
        })
        
        .catch((err) => console.error("Erreur récupération dashboard client :", err));
    });

    onUnmounted(() => {
      clearInterval(intervalId);
    });

    const greetingMessage = computed(() => {
      const hour = new Date().getHours();
      let greeting = "Bonjour";
      if (hour >= 18) greeting = "Bonsoir";
      else if (hour >= 12) greeting = "Bon après-midi";
      return `${greeting} ${clientName.value} 👋`;
    });

    return {
      projetsActifs,
      devisEnAttente,
      facturesImpayees,
      ticketsCount,
      ticketsGrowth,
      currentTime,
      clientName,
      greetingMessage,
    };
  },
};
</script>



